module.exports = __webpack_public_path__ + "static/media/FM_EU_Risk_Disclosure_and_Warnings_Notice_March_2025.b701a7de.pdf";